import elenardShop from './elenardShop.json';

export const categories = [
  {
    id: 'small-ring-jewelry-for-dreads-braids-and-locs',
    name: 'Art jewelry for hair, dreads, locs, and braids',
    slug: 'small-ring-jewelry-for-dreads-braids-and-locs',
  },
  {
    id: 'large-ring-jewelry-for-dreads-and-locs',
    name: 'Art jewelry for dreads and locs',
    slug: 'large-ring-jewelry-for-dreads-and-locs',
  },
];

export const products = [
  {
    id: 'p1',
    name: 'Copper hair pin (sample)',
    slug: 'copper-hair-pin-sample',
    categorySlug: categories[0].slug,
    price: 129,
    currency: 'USD',
    images: ['/assets/imgs/logo-light.svg'],
    description:
      'Sample product. Replace with real catalog via Admin/Backend.',
  },
  {
    id: 'p2',
    name: 'Dreadlock jewelry (sample)',
    slug: 'dreadlock-jewelry-sample',
    categorySlug: categories[1].slug,
    price: 149,
    currency: 'USD',
    images: ['/assets/imgs/logo-light.svg'],
    description:
      'Sample product. Replace with real catalog via Admin/Backend.',
  },
];

function parsePrice(priceText) {
  const m = String(priceText || '').match(/[\d,.]+/);
  if (!m) return null;
  const n = Number(m[0].replace(/,/g, ''));
  return Number.isFinite(n) ? n : null;
}

export function slugFromProductUrl(url) {
  try {
    const u = new URL(String(url));
    const parts = u.pathname.split('/').filter(Boolean);
    return parts[parts.length - 1] || null;
  } catch (_) {
    const parts = String(url || '').split('/').filter(Boolean);
    return parts[parts.length - 1] || null;
  }
}

export function getCategoryBySlug(slug) {
  return categories.find((c) => c.slug === slug) || null;
}

export function getProductBySlug(slug) {
  const fromMock = products.find((p) => p.slug === slug) || null;
  if (fromMock) return fromMock;

  const shopProducts = elenardShop?.products || [];
  const match = shopProducts.find((p) => slugFromProductUrl(p.url) === slug) || null;
  if (!match) return null;

  const price = parsePrice(match.priceText) ?? 0;
  const gallery = Array.isArray(match.images)
    ? match.images.filter(Boolean)
    : [match.image].filter(Boolean);
  const images = [...new Set(gallery)];
  return {
    id: `shop:${slug}`,
    name: match.name,
    slug,
    categorySlug: null,
    price,
    priceText: match.priceText || null,
    currency: 'USD',
    images,
    description: match.outOfStock
      ? 'This item is currently sold out. Please check back soon or contact us to be notified when it becomes available.'
      : 'This handcrafted copper piece requires approximately 70 hours of work per item. Designed as lightweight, durable jewelry suitable for various hairstyles, dreads, locs, and braids. Both front and back surfaces receive careful finishing attention. Each hair pin is one of a kind, with its unique design details and colour. The product arrives in sturdy packaging with ribbon, suitable for gifting. Includes a polishing cloth for maintenance.',
    care: 'Store in original box in a cool, dry location. Avoid water, lotions, perfumes, chemicals, and hairspray. Do not wear while showering, swimming, or exercising. Handle carefully to prevent damage. Polish with the included cloth when needed.',
    wearing: 'For fine hair, secure your hairstyle with a rubber band first, then wear the pin on top. Works beautifully with dreads, locs, braids, and thick hair.',
    shipping: 'All orders are shipped from Malaysia within 1–3 business days by FedEx Express with tracking, at no extra cost. Parcels may arrive as late as 11pm. US tariffs are covered by the seller. Returns are accepted within 14 days — contact us before sending anything back. Payment accepted via PayPal, Mastercard, and Visa.',
    externalUrl: match.url || null,
    outOfStock: !!match.outOfStock,
    badge: match.badge ?? null,
  };
}

export function getProductsByCategorySlug(slug) {
  return products.filter((p) => p.categorySlug === slug);
}

